/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_H1Inputs */

const en_viewer_ref_h1 = /** @type {(inputs: Viewer_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

const ko_viewer_ref_h1 = /** @type {(inputs: Viewer_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`값`)
};

const ja_viewer_ref_h1 = /** @type {(inputs: Viewer_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Viewer_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_h1 = /** @type {((inputs?: Viewer_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_h1(inputs)
	if (locale === "ko") return ko_viewer_ref_h1(inputs)
	return ja_viewer_ref_h1(inputs)
});